import { render } from "./CuentasCorrientesView.vue?vue&type=template&id=a0587e36"
import script from "./CuentasCorrientesView.vue?vue&type=script&lang=js"
export * from "./CuentasCorrientesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__